import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
import { themeClassNames } from "@utils/theme";
const WidgetWrapper = ({ id, children, theme, topMargin, bottomMargin, className }) => (_jsx("div", { className: cn("relative", theme && themeClassNames(theme), className), ...{ id }, style: { marginTop: topMargin, paddingBottom: bottomMargin }, children: children }));
export default WidgetWrapper;
